<template>
  <div class="row">
    <div v-bind:class="[firstContact ? 'col-md-6' : 'col-md-12']">
      <v-client-table class="contact-tab"
        :columns="contactsColumns"
        :data="contactsItems"
        :options="contactsOptions"
        @row-click="toggleActive"
      >
        <!-- <a slot="sujet" slot-scope="props" href="#" @click.prevent="showFiche(props.row.id)">{{ props.row.sujet }}</a> -->
        <a target="_blank" slot="sujet" slot-scope="props" ref="selected_subject"
          @click.prevent="showFiche($event, props.row.id)" style="cursor:pointer">{{ props.row.sujet }}</a>

        <div slot="message" slot-scope="props" @click.prevent="showFiche($event, props.row.id)" style="cursor:pointer">
          <span v-if="props.row.message.length>30">{{ props.row.message.substring(0,30) }} ...</span>
          <span v-else>{{ props.row.message }}</span>
        </div>
        <div v-if="props.row.created_at" slot="created_at" slot-scope="props" class="slot-date" @click.prevent="showFiche($event, props.row.id)" style="cursor:pointer">
          <span class="badge badge-success p-2">{{ formatDate(props.row.created_at) }}</span>
        </div>
      </v-client-table>
    </div>
    <div v-if="firstContact" class="col-md-6">
      <div class="card text-black border-info mb-3">
        <div class="card-header bg-info">
          <div class="cd-content">
            <b>Bénéficiaire</b> : {{ contact.prenom }} {{ contact.nom }} <br>
            <b>Sujet</b> : {{ contact.sujet }}
          </div>
        </div>
        <div class="card-body">
          <div class="cb-message">{{ contact.message }}</div>
        </div>
        <div class="card-footer">
          <span v-if="contact.hasFile">
            <div v-for="file in contact.fileName">
              <b-row>
                <b-col>
                  <i class="icon-paper-clip"></i>
                  <a style="margin-left:5px" href="#" @click.prevent="download(contact.user_id,contact.id, file)">
                    {{ file }}
                  </a>
                </b-col>
                <b-col v-if="contact.hasOpenedDossiers">
                  <i class="fa fa-share-square-o" @click.prevent="initiateAttachFile(file)" style="text-align:left;cursor:pointer;" title="Rattacher à un dossier"></i>
                </b-col>
              </b-row>
            </div>
          </span>
          <span v-else>
            <span><i>Aucune pièce envoyée</i></span>
          </span>
        </div>
      </div>
    </div>
    <b-modal title="Rattacher la pièce jointe à un dossier" id="modal-file-attach" ref="modal-file-attach">
      <b-row>
        <b-col sm="4">
          <b-form-group>
            <label for="dossierSelect"><strong>Dossier N°</strong></label>
            <b-input-group>
              <b-form-select
                id="dossierSelect"
                :plain="true"
                :options="dossierOptions"
                v-model="selectedDossier"
                class="mr-3">
                <!-- <template #first>
                  <b-form-select-option :value="null" >-- Sélectionnez un dossier --</b-form-select-option>
                </template> -->
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            class="float-right ml-2"
            @click="attachFileTo()">
            Valider
          </b-button>
          <b-button
            variant="danger"
            class="float-right"
            @click="$bvModal.hide('modal-file-attach')">
            Annuler
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../utils/auth'
import { downloadFile } from '@/utils/fileHelper'

export default {
  props: ['benefId'],
  data() {
    return {
      contactsColumns: ["created_at", "sujet", "message"],
      contactsItems: [],
      contactsOptions: {
        rowClassCallback(row) {
          return row.active ? 'highlight' : '';
        },
        headings: {
          created_at: "Date de création",
          sujet: "Sujet",
          message: "Message"
        },
        sortable: ["created_at"],
        filterable: false,
        perPage: 5,
        perPageValues: [5, 10, 20],
        texts: { filterPlaceholder: "Sujet" },
        orderBy: { column: "created_at", ascending: false }
      },
      contact : [],
      firstContact: '',
      dossierOptions: [],
      selectedDossier: '',
      openedDossiers: [],
      fileToAttach: ''
    }
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json'
    this.$axios.defaults.headers.common['Provider'] = getProvider()
  },
  mounted() {
    if (this.benefId) {
      this.contactList()
    }
  },
  methods: {
    toggleActive({row}) {

    },
    contactList() {
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .get('/espaceBeneficiaire/beneficiaires/contacts/' + this.benefId)
        .then(response => {
          this.contactsItems = response.data.contacts
          this.firstContact = response.data.contacts[0] ? response.data.contacts[0].id : null
          if (this.firstContact) {
            this.showFiche(this.$event, this.firstContact)
          }
          this.$event.emit('getContacts')
        })
        .catch(function(error) {console.log(error)})
    },
    formatDate(textDate) {
      let date = textDate !== null? new Date(textDate).toLocaleDateString('fr-FR') : '-'
      return date
    },
    showFiche(event, contactId) {
      this.contactsItems.forEach(element => {
        element.active = element.id === contactId ? true : false;
      });

      // let trParent = event.target.parentElement.parentElement

      // var elems = document.querySelectorAll(".highlight");
      // [].forEach.call(elems, function(el) {
      //   el.classList.remove("highlight");
      // });

      // trParent.classList.add('highlight')

      let self = this;
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .get("/espaceBeneficiaire/contacts/" + contactId)
        .then(response => {
          this.$store.commit("IS_LOADING", false);
          this.contact = response.data.contact
          this.contact.nom = this.contact.user.nom
          this.contact.prenom = this.contact.user.prenom
          this.openedDossiers = this.contact.openedDossiers
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    download(userId, contactId, fileName, ligneId) {
      let self = this;
      if (ligneId === undefined) { ligneId = null }
      let config = { 'userId': userId, 'contactId': contactId, 'fileName': fileName, 'ligneId': ligneId }
      let fileNameArr = fileName.split('.')
      let extension = fileNameArr.pop();
      let name = fileNameArr.join('.');
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .post("/espaceBeneficiaire/contacts/telechargement", config , {responseType: 'arraybuffer'}).then(response => {
          this.$store.commit("IS_LOADING", false);
          downloadFile(response, name, extension);
        })
        .catch(function(error) {
            self.$store.commit("IS_LOADING", false);
            let errorText = "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI"
            if (error.response && error.response.status === 404 && self !== undefined) {
              errorText = "La piéce justificatif demandée n'existe pas"
            }
            self.$swal({
            position: "top",
            type:"error",
            title:"Attention !!",
            text:errorText,
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    initiateAttachFile(file) {
      this.dossierOptions = []
      this.$bvModal.show('modal-file-attach')
      this.fileToAttach = file
      for (let dossier of this.openedDossiers) {
        this.dossierOptions.push({text: dossier.id, value: dossier.id});
      }
    },
    attachFileTo() {
      let dataPost = {}
      dataPost.file = this.fileToAttach
      dataPost.dossier_id = this.selectedDossier
      dataPost.is_visible_for_client = true
      dataPost.is_from_client = true
      dataPost.is_pj_ok = true
      dataPost.contact = this.contact
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .post('/espaceGestion/dossier-pieces-jointes/attachFile', dataPost)
        .then(() => {
          this.$store.commit('IS_LOADING', false)
          this.$swal({
            position: 'top',
            type: 'success',
            title: 'Rattachement avec succès',
            text: 'La pièce jointe a bien été rattachée au dossier n° ' + this.selectedDossier,
            showConfirmButton: false,
            timer: 4000
          });
          // this.$event.emit('refreshDossier');
          this.$bvModal.hide('modal-file-attach');
        })
        .catch((error) => {
          console.log(error)
          this.$store.commit('IS_LOADING', false)
          this.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue lors de l\'envoi du fichier. Si le problème persiste, merci de faire un ticket au support DOSI.',
            showConfirmButton: false,
            timer: 5000
          });
        })
        .finally(() => this.$store.commit('IS_LOADING', false));
    }
  }
}
</script>

<style>
  .cb-message {
    font-size: 15px;
  }
  .cd-content {
    font-size: 15px;
    line-height: 30px;
  }
  #fiche-beneficiaire .table-striped tbody tr.highlight {
    background-color: #ffc107;
  }
  #fiche-beneficiaire table.table-striped tbody tr td a {
    display: block;
  }
</style>
